import Select from '../Select/Select';
import SelectAndDisplay from '../Select/SelectAndDisplay';
import Tools from '../Tools/Tools';
import AdvertCustomization from '../Wizard/AdvertCustomization';
import PriceThresholds from '../Wizard/PriceThresholds';

class ZoneBanner {
	constructor() {
		if (document.getElementById('react-create-zone')) {
			return;
		}

		this.section = document.querySelector('.Wizard--zone .Form--banner');

		if (this.section) {
			// eslint-disable-next-line no-new
			new AdvertCustomization(this.section);

			// V budoucnu IM, Pubmatic, Appnexus.
			this.zonesSubcategories = ['Sklik', 'IM', 'Pubmatic', 'Xandr'];
			this.handlePriceThresholds();

			//this.listenOnInput();
			this.initAdvertSelects();
			this.initBannerSizes();
			this.initAdCount();
			this.initChannelTypes();
			this.initSectionToggles();
			this.listenOnDeliveryTypeChange();
		}
	}

	/**
	 * Pokud je sekce deaktivovaná, tak jí nelze upravovat.
	 */
	initSectionToggles() {
		const toggleClasses = this.zonesSubcategories
			.map((subcategory) => '.TabNav-item--' + subcategory + ' input.Toggle')
			.join(', ');

		const toggles = Array.from(this.section.querySelectorAll(toggleClasses));

		const sectionClasses = this.zonesSubcategories.map((subcategory) => '.TabNav-content--' + subcategory).join(', ');

		const sections = Array.from(this.section.querySelectorAll(sectionClasses));

		toggles.forEach((toggle, index) => {
			const dataEnabled = Tools.getParentByClass(toggle, 'TabNav-item').getAttribute('data-enabled') !== 'false';

			if (!toggle.checked || !dataEnabled) {
				sections[index].style.opacity = '0.5';
				sections[index].style.pointerEvents = 'none';
			}

			toggle.addEventListener('click', (e) => {
				if (!dataEnabled) {
					e.preventDefault();

					return;
				}

				if (e.target.checked) {
					sections[index].style.opacity = '1';
					sections[index].style.pointerEvents = 'auto';
				} else {
					sections[index].style.pointerEvents = 'none';
					sections[index].style.opacity = '0.5';
				}
			});
		});
	}

	/**
	 * Akce při výberu typu reklamy.
	 * @param {string} selected
	 */
	onSelectAdvertType(selected, select) {
		select.toggleSelect();

		if (selected !== select.getSelectedOption()) {
			select.setSelectOption(selected);
			select.serviceHiddenInputs(selected);
		}
	}

	/**
	 * Selectboxy pro nastavení zony.
	 */
	initAdvertSelects() {
		const advertTypeElement = this.section.querySelector('.Select-advert-type');
		const advertTypeSelect = new Select();

		advertTypeSelect.initSelectWithElement(advertTypeElement, this.onSelectAdvertType.bind(this));

		const choiceAdvertTypeElement = this.section.querySelector('.Select-choice-advert-type');

		const choiceAdvertTypeSelect = new Select();

		choiceAdvertTypeSelect.initSelectWithElement(choiceAdvertTypeElement, this.onSelectAdvertType.bind(this));
	}

	/**
	 * Zajištuje propisování hodnot CPT, Adblock apod. do dolních podkategorií.
	 */
	handlePriceThresholds() {
		// eslint-disable-next-line no-new
		new PriceThresholds(
			this.section,
			this.zonesSubcategories, // Podsekce.
		);
	}

	/**
	 * Selectboxy pro nastavení poctu inzeratu.
	 */
	initAdCount() {
		const adCountElement = this.section.querySelector('.Select-text-ad-count');
		const adCountSelect = new Select();

		adCountSelect.initSelectWithElement(adCountElement, this.onSelectAdvertType.bind(this));
	}

	/**
	 * Tato funkce nastaví obsluhu rozměrů banerů.
	 */
	initBannerSizes() {
		const mainBannerSizes = this.section.querySelector(
			'.Form-wrapper--zone .Form-section-content--bannerSizes .Select-bannerSizes',
		);

		const bannerSizes = new SelectAndDisplay(
			mainBannerSizes,
			[window.SSP.translations.form.labels.sizes, window.SSP.translations.form.labels.noMoreSizes],
			'Common',
		);

		this.zonesSubcategories.forEach((subcategory) => {
			const banner = this.section.querySelector(
				`.TabNav-content--${subcategory} .Form-section-content--bannerSizes .Select-bannerSizes`,
			);

			bannerSizes.setChildren(banner, subcategory);
		});
	}

	setColorSettings(opacity, event) {
		this.colorSettings.style.pointerEvents = event;
		this.colorSettings.style.opacity = opacity;
	}

	/**
	 * Pokud je zaskrtnuty radio HTML nebo JSON
	 * zobrazime input s poctem inzeratu
	 */
	toggleAdCountVisibility(adCountWrapper, { value }) {
		const adCountInput = document.querySelector('[name="dsps-sklik-settings-text_ad_count"]');

		if (value === 'code' || value === 'json') {
			adCountWrapper.classList.remove('is-hidden');

			if (adCountInput) {
				adCountInput.disabled = false;
			}

			if (adCountWrapper.classList.contains('js-advert-count-sklik')) {
				this.setColorSettings('0.5', 'none');
			}
		} else {
			adCountWrapper.classList.add('is-hidden');

			if (adCountInput) {
				adCountInput.disabled = true;
			}

			if (adCountWrapper.classList.contains('js-advert-count-sklik')) {
				this.setColorSettings('1', 'auto');
			}
		}
	}

	connectDeliveryTypeInputs(adCountWrapper) {
		const subInputs = Array.from(document.querySelectorAll('.Form-box .js-delivery-type input'));

		const commonInputs = Array.from(document.querySelectorAll('.Common-delivery-type input'));

		commonInputs.forEach((input) => {
			input.addEventListener('change', (e) => {
				subInputs.forEach((subInput) => {
					subInput.checked = e.target.value === subInput.value;
				});

				this.toggleAdCountVisibility(adCountWrapper, e.target);
			});
		});
	}

	listenOnDeliveryTypeChange() {
		const deliveryTypeWrapper = document.querySelector('.js-delivery-type');
		const adCountWrapper = document.querySelector('.js-advert-count');

		this.colorSettings = document.querySelector('.Form-section--colorSettings');

		// Nekteri uzivatele nevidi toto nastavení.
		if (!deliveryTypeWrapper || !adCountWrapper) {
			return;
		}

		// Podkategorie Sklik obsahuje select s počtem inzerátů, který se zobrazuje/schovává.
		const sklikDeliveryInputs = Array.from(document.querySelectorAll('.Sklik-delivery-type input'));

		sklikDeliveryInputs.forEach((subInput) =>
			subInput.addEventListener('change', (e) => {
				this.toggleAdCountVisibility(adCountWrapper, e.target);
			}),
		);

		// Výchozí nastavení zobrazení počtu inzerátů.
		const checkedType = document.querySelector('.Sklik-delivery-type input:checked');

		if (checkedType) {
			this.toggleAdCountVisibility(adCountWrapper, checkedType);
		} else {
			this.setColorSettings('0.5', 'none');
		}

		// Nastavení typu výdeje z hlavičky formuláře.
		this.connectDeliveryTypeInputs(adCountWrapper);
	}

	/**
	 * Pokud je u IM zadano externí ID a jsou vybrané rozměry,
	 * tak je sekce aktivní.
	 */
	listenOnInput() {
		document.querySelector('.IM-externalId input').addEventListener('input', (e) => {
			if (e.target.value.length) {
				if (document.querySelectorAll('.TabNav-content--IM .Form-selectedItems li').length) {
					document.querySelector('.TabNav-item--IM input').checked = true;
				}
			} else {
				document.querySelector('.TabNav-item--IM input').checked = false;
			}
		});
	}

	/**
	 * Inicializuje select pro nastavení druhu kanálu.
	 */
	initChannelTypes() {
		const mainChannelTypes = this.section.querySelector(
			'.Form-section-content.Form-section-content--canalTypes .Select',
		);

		// eslint-disable-next-line no-new
		new SelectAndDisplay(mainChannelTypes, [
			window.SSP.translations.form.labels.channels,
			window.SSP.translations.form.labels.noMoreChannels,
		]);
	}
}

export default ZoneBanner;
